// Tüm sayfalarda paylaşılan marka teması. Önceden bu gradient 7 ayrı dosyada kopyalanmıştı
// (Home/Login/Register/Settings/StartMigration/KeepMigration/MigrationStatus) — artık tek
// kaynak burası, renk değişmiyor, sadece bakım tek yerden yapılıyor.

export const brandColors = {
  blueDark: '#1e3c72',
  blueLight: '#2a5298',
  red: '#a3001e',
  purple: '#6a0572',
  green: '#43a047',
};

export const diagonalStripes = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='40' height='40' fill='none'/%3E%3Cpath d='M-10 10L10 -10M0 40L40 0M30 50L50 30' stroke='white' stroke-width='1' stroke-opacity='0.15'/%3E%3C/svg%3E")`;

export const brandGradient = `linear-gradient(120deg, ${brandColors.blueLight} 0%, ${brandColors.blueDark} 40%, ${brandColors.red} 60%, ${brandColors.purple} 100%)`;

// Wordmark'ta (ör. Home hero) kullanılan ayırt edici gösterim fontu — Google Fonts'tan
// public/index.html'de yükleniyor, burada sadece font-family referansı.
export const wordmarkFontFamily = '"Poppins", "Helvetica Neue", Arial, sans-serif';

// Sayfa arka planı: aynı renkler, sadece çok yavaş (22s) ve yumuşak bir kayma animasyonu ile.
// Palet değişmiyor, sadece gradient'in görünen kısmı yavaşça kayıyor. prefers-reduced-motion
// (hareket hassasiyeti) ayarı açık olan kullanıcılarda animasyon otomatik devre dışı kalıyor
// (bkz. index.css @media sorgusu).
export const pageBackgroundSx = {
  minHeight: '100vh',
  width: '100%',
  background: `${brandGradient}, ${diagonalStripes}`,
  backgroundBlendMode: 'overlay',
  backgroundSize: '300% 300%, 40px 40px',
  animation: 'xpaGradientShift 22s ease-in-out infinite',
  color: '#fff',
};
